<div class="modal-content-detail">
    <div class="modal-background">
        <div class="modal-header">
            <button type="button" class="close" (click)="dismiss()" aria-label="Close">
                <img src="./assets/images/icon/btn-close.svg">
            </button>

            <span class="modal-body__title">Đặt lịch tư vấn</span>
        </div>
        <div class="modal-body">
           <form-create-appointment></form-create-appointment>
        </div>
    </div>
</div>